export default {
    data() {
        return {
            applicationName: 'StudentFunding.App',
            applicationTitle: 'Student Funding',
        }
    },
    computed: {
        AppUri() { return process.env.BASE_URL; },
        InDevelopment() { return window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('staging.azurewebsites.net') > -1; },
    },
};